/**
 * "Still not working? Report a problem" on a finished ticket (9 Oct).
 *
 * A Closed ticket is final in Ivanti: nothing can reopen it, so a comment box
 * there would be a dead end (LIVE SR 10578 was a Fulfilled request whose
 * reply went unnoticed). Instead the person raises a new incident that names
 * this ticket, and the server gives it to this ticket's owner and team.
 */

import { ArrowRight, Icon } from "@norican/icons";
import { Button, Typography } from "@norican/react";
import { useNavigate } from "react-router";

import { useT } from "@/i18n";

import { reportProblemPath } from "../lib/finished-reply";

export interface ReportProblemPanelProps {
  ticketId: string;
  kind: string;
}

export function ReportProblemPanel({ ticketId, kind }: ReportProblemPanelProps) {
  const { t } = useT("tickets");
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-1">
        <Typography variant="body" className="font-semibold">
          {kind === "SERVICE_REQUEST"
            ? t("reportProblem.completeRequest")
            : t("reportProblem.completeIncident")}
        </Typography>
        <Typography variant="body-sm" tone="muted">
          {t("reportProblem.stillNotWorking")}
        </Typography>
      </div>
      <Button
        className="self-start sm:self-auto"
        endIcon={<Icon icon={ArrowRight} size="sm" />}
        onClick={() => void navigate(reportProblemPath(ticketId))}
      >
        {t("reportProblem.action")}
      </Button>
    </div>
  );
}
